/**
 * Responsive video embeds
 *
 * - Autowraps YouTube and Vimeo iframes in Foundation's `.responsive-embed` container
 * - Excludes iframes with class `non-responsive-embed` or `data-responsive-embed="false"`
 */

const EMBED_SELECTOR = 'iframe[src*="youtube.com"], iframe[src*="vimeo.com"]';
const EXCLUDED_CLASSES = ['non-responsive-embed']; // 'not_responsive_video'

function isResponsiveEmbed(iframe) {
	if (iframe.dataset.responsiveEmbed === 'false') return false;
	return !EXCLUDED_CLASSES.some((className) => iframe.classList.contains(className));
}

/**
 * Wraps matching YouTube/Vimeo iframes in a `.responsive-embed.widescreen` container
 */
export function initResponsiveVideoEmbeds() {
	document.querySelectorAll(EMBED_SELECTOR).forEach((iframe) => {
		if (!isResponsiveEmbed(iframe)) return;

		const wrapper = document.createElement('div');
		wrapper.className = 'responsive-embed widescreen';

		iframe.replaceWith(wrapper);
		wrapper.appendChild(iframe);
	});
}

/**
 * Auto-initializes responsive video embeds when DOM is ready
 */
export function autoInitResponsiveVideoEmbeds() {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initResponsiveVideoEmbeds);
	} else {
		initResponsiveVideoEmbeds();
	}
}

autoInitResponsiveVideoEmbeds();

// Default export so other modules can use
export default {
	initResponsiveVideoEmbeds,
	autoInitResponsiveVideoEmbeds
};
